export const LOCAL_STORAGE_AUTH_TOKEN = 'jwtToken';
export const LOCAL_STORAGE_ORGANIZATION_AUTH_TOKEN = 'organizationJwtToken';
export const LOCAL_STORAGE_AUTH = 'auth';
export const LOCAL_STORAGE_USER_DATA = 'userData';
export const LOCAL_STORAGE_ORGANIZATION_USER_DATA = 'organizationUserData';
export const LOCAL_STORAGE_USER_ORGANIZATIONS = 'userOrganizations';
export const LOCAL_STORAGE_SELECTED_ORGANIZATIONS = 'selectedOrganization';
